import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const VerifyEmail: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'pending' | 'ok' | 'fail'>('pending');
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    // StrictMode runs effects twice in dev — token must be consumed only once.
    if (ran.current) return;
    ran.current = true;

    const token = params.get('token');
    if (!token) {
      setStatus('fail');
      setError('Nedostaje token u linku.');
      return;
    }

    (async () => {
      try {
        const res = await fetch('/auth/v1/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const body = await res.json();
        if (!res.ok) throw new Error(body.error_description || body.error || 'Verifikacija nije uspela');

        // Drop the returned session into supabase-js so the user lands logged in.
        await supabase.auth.setSession({
          access_token: body.access_token,
          refresh_token: body.refresh_token,
        });
        setStatus('ok');
        setTimeout(() => navigate('/admin/dashboard'), 1500);
      } catch (e: any) {
        setStatus('fail');
        setError(e.message);
      }
    })();
  }, [params, navigate]);

  return (
    <div style={page}>
      <div style={card}>
        {status === 'pending' && <p>Verifikujem...</p>}
        {status === 'ok' && (
          <>
            <h1 style={{ marginTop: 0, color: '#16a34a' }}>✓ Verifikovano!</h1>
            <p>Vaša prodavnica je aktivirana. Preusmeravam vas u admin panel...</p>
          </>
        )}
        {status === 'fail' && (
          <>
            <h1 style={{ marginTop: 0, color: '#dc2626' }}>✗ Greška</h1>
            <p>{error}</p>
            <a href="/login" style={{ color: '#0f172a' }}>
              Idi na prijavu
            </a>
          </>
        )}
      </div>
    </div>
  );
};

const page: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f8fafc',
  padding: 20,
};

const card: React.CSSProperties = {
  width: '100%',
  maxWidth: 440,
  background: '#fff',
  padding: 32,
  borderRadius: 8,
  border: '1px solid #e5e7eb',
  textAlign: 'center',
};

export default VerifyEmail;
